import styles from "./main-app-menu.module.css";
import { usePaths } from "BEDROCK/paths";
import { MenuOption } from "./components";
import { resetTooltips } from "PosterEditor/tooltips";

interface UserContentProps {
  email: string | null;
  didClickOption: () => void;
}

export const ContentUser = (props: UserContentProps) => {
  const { myOrders, myAccount, navigateTo } = usePaths();
  return (
    <div className={styles.userContent}>
      <MenuOption
        label={"My account"}
        subtitle={props.email ?? "No email"}
        icon="USER"
        onClick={() => {
          navigateTo(myAccount);
          props.didClickOption();
        }}
      />

      <MenuOption
        label="Orders"
        icon="FOLDER"
        onClick={() => {
          navigateTo(myOrders);
          props.didClickOption();
        }}
      />

      <MenuOption
        label="Reset tooltips"
        icon="INFO"
        onClick={() => {
          resetTooltips();
          props.didClickOption();
        }}
      />
    </div>
  );
};
